import React from 'react';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const KYCHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="kyc-header">
      <button className="kyc-back" onClick={() => navigate(-1)}>
        <ArrowLeft size={20}/>
      </button>
      <div className="kyc-header__info">
        <h2 className="kyc-title">KYC Verification</h2>
      </div>
      <div className="kyc-header__icon">
        <ShieldCheck size={22}/>
      </div>
    </div>
  );
};

export default KYCHeader;